import { render, staticRenderFns } from "./page.vue?vue&type=template&id=bad4af98&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.css?vue&type=style&index=0&id=bad4af98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4af98",
  null
  
)

export default component.exports